import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Hooks
import { useStylesV2 } from '@kubit/web-ui-product-components';
// Components
import { TitleComponent } from '../../components/title/title.component';
import { ParagraphComponent } from '../../components/paragraph/paragraph.component';
import { EmptyStatusActionsComponent } from '../../components/empty-status/components/empty-status-actions/empty-status-actions.component';
import { EmptyStatusIllustrationLoaderComponent } from '../../components/empty-status/components/illustration-loader/illustration-loader.component';
// Constants
import { STYLES_NAME } from '../../constants/stylesName';
// Styles
import { EmptyStatusComponentStyled, EmptyStatusTitleStyled, } from '../../components/empty-status/empty-status.component.styled';
//Configurations
import { titleProps, paragraphProps, } from '../../components/empty-status/configuration/empty-status-props';
const EmptyStatusComponent = (props) => {
    const styles = useStylesV2({
        styleName: STYLES_NAME.EMPTY_STATUS,
        variantName: props.variant,
    });
    return (_jsxs(EmptyStatusComponentStyled, { "data-testId": props?.dataTestId, styles: styles, children: [_jsx(EmptyStatusIllustrationLoaderComponent, { ...props }), _jsx(EmptyStatusTitleStyled, { styles: styles, children: _jsx(TitleComponent, { ...titleProps, component: props?.titleComponentType, showBuilder: false, title: props.title }) }), _jsx(ParagraphComponent, { ...paragraphProps, children: props?.description }), _jsx(EmptyStatusActionsComponent, { ...props, styles })] }));
};
export { EmptyStatusComponent };
//# sourceMappingURL=empty-status.component.js.map